import styled from "styled-components";
import {VoucherCardSideDefaultBox} from "./voucher-card-side.default.box";

export const VoucherCardSideCasino777Box = styled(VoucherCardSideDefaultBox)`
    color: unset;
`;
